import type {IEventManagerWithAsync} from '@gongxigames/framework/core/types/IEventManager';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {SplashScreen} from '@gongxigames/framework/slot/init';

export class SplashScreenWarper {
    private destroyListener = this.destroy.bind(this);

    private splashScreen?: SplashScreen;
    private eventManager?: IEventManagerWithAsync;

    public init(
        splashScreen: SplashScreen,
        eventManager: IEventManagerWithAsync
    ): void {
        this.splashScreen = splashScreen;
        this.eventManager = eventManager;
        this.addEvents();
    }

    private on(id: string | symbol): void {
        this.eventManager!.onAsync(id, this.destroyListener, this);
    }

    private off(id: string | symbol): void {
        this.eventManager!.offAsync(id, this);
    }

    private addEvents(): void {
        this.on(LogicEvents.CONNECTION_TIMEOUT);
        this.on(LogicEvents.CONNECTION_SLOW);
        this.on(LogicEvents.CONNECTION_ERROR);
        this.on(LogicEvents.GAME_UNAVAILABLE);
        this.on(LogicEvents.PLACE_BET_ERROR);
        this.on(LogicEvents.TEMPORARY_ERROR);
        this.on(LogicEvents.GAMESERVER_ERROR);
        this.on(LogicEvents.INVALID_BALANCE);
        this.on('General.Message.SHOW');

        this.eventManager!.on('General.Message.SHOW', this.destroy.bind(this), this);
        this.eventManager!.on('General.Game.HIDE_SPLASH_SCREEN', this.destroy.bind(this), this);
    }

    private removeEvents(): void {
        this.off(LogicEvents.CONNECTION_TIMEOUT);
        this.off(LogicEvents.CONNECTION_SLOW);
        this.off(LogicEvents.CONNECTION_ERROR);
        this.off(LogicEvents.GAME_UNAVAILABLE);
        this.off(LogicEvents.PLACE_BET_ERROR);
        this.off(LogicEvents.TEMPORARY_ERROR);
        this.off(LogicEvents.GAMESERVER_ERROR);
        this.off(LogicEvents.INVALID_BALANCE);
        this.off('General.Message.SHOW');

        this.eventManager!.off('General.Message.SHOW', this);
        this.eventManager!.off('General.Game.HIDE_SPLASH_SCREEN', this);
    }

    public async hide(): Promise<void> {
        await this.splashScreen!.awaitSplashHide();
        this.destroy();
    }

    public restore(): void {
        this.splashScreen!.restore();
        this.addEvents();
    }

    private destroy() {
        this.splashScreen?.removeFromDOM();
        this.removeEvents();
    }
}
